export enum CALL_TYPE {
  Voicemail = "voicemail",
  Recording = "recording",
}
